(function () {
  var sticky = document.getElementById('fx-sticky-atc');
  if (sticky && 'IntersectionObserver' in window) {
    var anchor = document.querySelector('.product-form__submit');
    if (anchor) {
      var sio = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.hidden = !passed;
          });
        },
        { threshold: 0 }
      );
      sio.observe(anchor);
    }
  }
})();

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  if (document.hidden) return;
  var targets = document.querySelectorAll('.title-wrapper, .rich-text__blocks');
  if (!targets.length) return;
  document.documentElement.classList.add('fx-motion');
  var revealAll = function () {
    targets.forEach(function (t) {
      t.classList.add('fx-in');
    });
  };
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fx-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );
  targets.forEach(function (t, i) {
    t.classList.add('fx-reveal');
    t.style.transitionDelay = (i % 4) * 60 + 'ms';
    io.observe(t);
  });
  setTimeout(revealAll, 2500);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) revealAll();
  });
})();

(function () {
  var guarded = '.product__media-list, .thumbnail-list, .product-media-modal__content';
  var block = function (event) {
    if (event.target.closest && event.target.closest(guarded)) event.preventDefault();
  };
  document.addEventListener('contextmenu', block);
  document.addEventListener('dragstart', block);
})();

(function () {
  // The WhatsApp link is server-rendered once; rebuild it at click time so the
  // message carries the size/colour the shopper picked after page load.
  function waHref(link) {
    var info = link.closest('product-info') || document;
    var parts = [];
    var variant = null;
    var json = info.querySelector('variant-selects script[data-selected-variant]');
    if (json) {
      try {
        variant = JSON.parse(json.textContent);
      } catch (e) {}
    }
    if (variant && variant.title && variant.title !== 'Default Title') parts.push(variant.title);
    var color = info.querySelector('product-color-gallery input[type="radio"]:checked');
    if (color) parts.push(color.getAttribute('aria-label'));
    var url = new URL(link.dataset.productUrl);
    if (variant && variant.id) url.searchParams.set('variant', variant.id);
    if (color) url.searchParams.set('color', color.value);
    var text =
      link.dataset.message +
      ' ' +
      link.dataset.productTitle +
      (parts.length ? ' (' + parts.join(', ') + ')' : '') +
      ' — ' +
      url.href;
    return 'https://wa.me/' + link.dataset.waNumber + '?text=' + encodeURIComponent(text);
  }
  function refresh(event) {
    var link = event.target.closest && event.target.closest('a[data-fx-wa]');
    if (link) link.href = waHref(link);
  }
  document.addEventListener('click', refresh, true);
  document.addEventListener('auxclick', refresh, true);
})();

(function () {
  // send_to keeps these out of the Ads tag (AW-16568172787) that the same
  // Google app configures on the page.
  var GA4_ID = 'G-K41VD21BX3';
  var MAPS = /^https?:\/\/((www\.)?google\.[a-z.]+\/maps|maps\.google\.[a-z.]+\/|maps\.app\.goo\.gl\/)/i;
  var WHATSAPP = /^https?:\/\/(wa\.me|api\.whatsapp\.com)\//i;

  function leadEvent(href) {
    if (/^tel:/i.test(href)) return 'call_click';
    if (WHATSAPP.test(href)) return 'whatsapp_click';
    if (MAPS.test(href)) return 'directions_click';
    return null;
  }

  function track(event) {
    try {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      // Review links open the Maps listing too; counting them as directions or a Meta Contact would inflate leads.
      var isReview = link.getAttribute('data-lead') === 'reviews';
      var name = isReview ? 'reviews_click' : leadEvent(href);
      if (!name) return;
      var holder = link.closest('[data-showroom]');
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, {
          send_to: GA4_ID,
          showroom: (holder && holder.getAttribute('data-showroom')) || 'unknown',
          page_path: location.pathname,
          // GA4 caps event parameter values at 100 characters.
          link_url: href.slice(0, 100),
          transport_type: 'beacon'
        });
      }
      if (!isReview && typeof window.fbq === 'function') window.fbq('track', 'Contact');
    } catch (e) {}
  }

  document.addEventListener('click', track, true);
})();
